import React from 'react';
import { ExportContext, useExportCoordinator } from '../viewmodels/useExportCoordinator';
export default function AttendanceExportsProvider({ children }) {
  const vm = useExportCoordinator();
  return <ExportContext.Provider value={vm}>{children}</ExportContext.Provider>;
}
